import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm$ruleToDelete, _vm$ruleToResolve;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bridge-monitoring-rules"
  }, [_c(VRow, [_c(VCol, [_c('h3', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.title')))])]), _c(VCol, {
    staticClass: "text-right"
  }, [_c(VBtn, {
    class: 'v-btn-x mr-2 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.update'),
      "icon": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.fetchRules
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-sync-alt")])], 1), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.openRuleDialog();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.addNew')) + "\n      ")])], 1)], 1), _vm.rules.length > 0 ? _c(VRow, {
    staticClass: "mt-4"
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSimpleTable, {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$i18n_t('Common.id')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.table.severity')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.table.name')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.table.state')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.table.type')))]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.table.enabled')))]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.table.silenced')))]), _c('th', {
          staticClass: "text-right"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.table.history')))]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.actions')))])])]), _c('tbody', _vm._l(_vm.rules, function (rule) {
          return _c('tr', {
            key: rule.id
          }, [_c('td', [_vm._v(_vm._s(rule.id))]), _c('td', [_c(VIcon, {
            attrs: {
              "small": "",
              "color": _vm.getSeverityColor(rule.properties.severity),
              "title": _vm.$i18n_t(`Connectors.Monitoring.rules.severity.${rule.properties.severity}`)
            }
          }, [_vm._v("\n                  fa fa-exclamation-triangle\n                ")])], 1), _c('td', [_vm._v(_vm._s(rule.name))]), _c('td', [_c(VChip, {
            attrs: {
              "color": _vm.getStateColor(rule.state),
              "small": ""
            }
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t(`Connectors.Monitoring.rules.states.${rule.state}`)) + "\n                ")])], 1), _c('td', [_vm._v(_vm._s(rule.ruleType))]), _c('td', {
            staticClass: "text-center"
          }, [_c(VSwitch, {
            attrs: {
              "color": _vm.color,
              "hide-details": ""
            },
            on: {
              "change": function ($event) {
                return _vm.toggleEnabled(rule);
              }
            },
            model: {
              value: rule.enabled,
              callback: function ($$v) {
                _vm.$set(rule, "enabled", $$v);
              },
              expression: "rule.enabled"
            }
          })], 1), _c('td', {
            staticClass: "text-center"
          }, [_c(VSwitch, {
            attrs: {
              "color": _vm.color,
              "hide-details": ""
            },
            on: {
              "change": function ($event) {
                return _vm.toggleSilenced(rule);
              }
            },
            model: {
              value: rule.silenced,
              callback: function ($$v) {
                _vm.$set(rule, "silenced", $$v);
              },
              expression: "rule.silenced"
            }
          })], 1), _c('td', {
            staticClass: "text-right"
          }, [_c(VIcon, {
            staticClass: "mr-4",
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.showHistory'),
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.openHistoryDialog(rule);
              }
            }
          }, [_vm._v("\n                  fal fa-calendar-alt\n                ")])], 1), _c('td', {
            staticClass: "text-center"
          }, [_c(VTooltip, {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function ({
                on,
                attrs
              }) {
                return [_c(VIcon, _vm._g(_vm._b({
                  staticClass: "mr-1",
                  attrs: {
                    "color": _vm.color,
                    "small": ""
                  },
                  on: {
                    "click": function ($event) {
                      return _vm.openRuleDialog(rule);
                    }
                  }
                }, 'v-icon', attrs, false), on), [_vm._v("\n                      fal fa-edit\n                    ")])];
              }
            }], null, true)
          }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('Common.edit')))])]), _c(VTooltip, {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function ({
                on,
                attrs
              }) {
                return [_c(VIcon, _vm._g(_vm._b({
                  staticClass: "mr-1",
                  attrs: {
                    "color": rule.state === 'firing' ? 'success' : 'grey',
                    "disabled": rule.state !== 'firing',
                    "small": ""
                  },
                  on: {
                    "click": function ($event) {
                      rule.state === 'firing' && _vm.openResolveDialog(rule);
                    }
                  }
                }, 'v-icon', attrs, false), on), [_vm._v("\n                      fal fa-check-circle\n                    ")])];
              }
            }], null, true)
          }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.actions.resolve')))])]), _c(VTooltip, {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function ({
                on,
                attrs
              }) {
                return [_c(VIcon, _vm._g(_vm._b({
                  attrs: {
                    "color": _vm.color,
                    "small": ""
                  },
                  on: {
                    "click": function ($event) {
                      return _vm.deleteRule(rule);
                    }
                  }
                }, 'v-icon', attrs, false), on), [_vm._v("\n                      fal fa-trash-alt\n                    ")])];
              }
            }], null, true)
          }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('Common.delete')))])])], 1)]);
        }), 0)];
      },
      proxy: true
    }], null, false, 4156366335)
  })], 1)], 1) : _c(VRow, {
    staticClass: "mt-4"
  }, [_c(VCol, {
    staticClass: "text-center py-8"
  }, [_c(VIcon, {
    attrs: {
      "size": "48",
      "color": "grey"
    }
  }, [_vm._v("fal fa-bell-slash")]), _c('p', {
    staticClass: "text--secondary mt-4"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.empty')) + "\n      ")])], 1)], 1), _c('bridge-monitoring-rule-dialog', {
    attrs: {
      "rule": _vm.selectedRule,
      "bridge-id": _vm.bridgeId,
      "monitoring-config-id": _vm.monitoringConfigId,
      "monitoring-config": _vm.monitoringConfig,
      "tenant-id": _vm.tenantId
    },
    on: {
      "save": _vm.saveRule
    },
    model: {
      value: _vm.ruleDialog,
      callback: function ($$v) {
        _vm.ruleDialog = $$v;
      },
      expression: "ruleDialog"
    }
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('Connectors.Monitoring.rules.deleteConfirmation.title'),
      "open": _vm.deleteDialog,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'red',
        emit: 'delete'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.deleteDialog = false;
      },
      "delete": _vm.confirmDeleteRule,
      "close": function ($event) {
        _vm.deleteDialog = false;
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.deleteConfirmation.message', {
    name: ((_vm$ruleToDelete = _vm.ruleToDelete) === null || _vm$ruleToDelete === void 0 ? void 0 : _vm$ruleToDelete.name) || ''
  })))])]), _c(VDialog, {
    attrs: {
      "max-width": "500",
      "persistent": ""
    },
    model: {
      value: _vm.resolveDialog,
      callback: function ($$v) {
        _vm.resolveDialog = $$v;
      },
      expression: "resolveDialog"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    class: `headline ${_vm.color}--text`
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.resolveDialog.title')) + "\n      ")]), _c(VCardText, {
    staticClass: "pt-4"
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.resolveDialog.message', {
    name: ((_vm$ruleToResolve = _vm.ruleToResolve) === null || _vm$ruleToResolve === void 0 ? void 0 : _vm$ruleToResolve.name) || ''
  })))]), _c(VTextarea, {
    staticClass: "mt-4",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.resolveDialog.reason'),
      "rows": "3",
      "placeholder": _vm.$i18n_t('Connectors.Monitoring.rules.resolveDialog.reasonPlaceholder')
    },
    model: {
      value: _vm.resolutionReason,
      callback: function ($$v) {
        _vm.resolutionReason = $$v;
      },
      expression: "resolutionReason"
    }
  })], 1), _c(VDivider), _c(VCardActions, [_c(VSpacer), _c(VBtn, {
    attrs: {
      "color": "grey",
      "text": ""
    },
    on: {
      "click": _vm.closeResolveDialog
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.cancel')) + "\n        ")]), _c(VBtn, {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": _vm.confirmResolveRule
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.actions.resolve')) + "\n        ")])], 1)], 1)], 1), _c('rule-history-dialog', {
    attrs: {
      "rule-id": _vm.selectedRuleForHistory
    },
    model: {
      value: _vm.historyDialog,
      callback: function ($$v) {
        _vm.historyDialog = $$v;
      },
      expression: "historyDialog"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };